import { const_var, params } from "../../redux/reducers/reducer";

export const updateAlertMessage = (alertUsedFor) => {
	let alertMessage = "";

	if (alertUsedFor == "restrictedBuildingHeight") {
		alertMessage = "Please increase the building's height or adjust the roof pitch to design the building with the selected width.";
	}
	if (alertUsedFor == "ShowPromptForApplyDiscount") {
		alertMessage = "Offer cannot be applied.";
	}
	if (alertUsedFor == "restrictedBuildingHeight1") {
		alertMessage = "Please decrease the building's width or adjust the roof pitch to design the building with the selected height.";
	}

	if (alertUsedFor == "noSpaceForComponent") {
		alertMessage = "To add or modify a component, the building dimensions need to be increased.";
	}

	if (alertUsedFor == "noClearanceForComponent") {
		alertMessage = "Components may be removed due to height clearance differences. Review the design before finalizing.";
	}

	if (alertUsedFor == "noSpaceForComponentDuringLoading") {
		alertMessage = "Overlapping doors and windows added during building design will be subject to automatic removal.";
	}
	if (alertUsedFor == "publicAccessURL") {
		alertMessage = const_var.alertPubliMessage;
	}
	if (alertUsedFor == "ManageKlinkExpire") {
		alertMessage = const_var.alertExpireMessage;
	}
	if (alertUsedFor == "ManageKlinkMessage") {
		alertMessage = "Please note that updating the quote will deactivate the current K-link. You will need to generate a new K-link for sharing.";
	}

	if (alertUsedFor == "showOverheadOldQuoteOrderMsg") {
		alertMessage = "This manufacturer's prices have been updated. Please review the total cost of this building before making any updates.";
	}
	if (alertUsedFor == "noSpaceToAddCupola") {
		alertMessage = "This item doesnÃ¢â‚¬â„¢t fit and canÃ¢â‚¬â„¢t be placed on the selected wall.";
	}
	if (alertUsedFor == "noSpaceToUpdateCupola") {
		alertMessage = "This item size doesnÃ¢â‚¬â„¢t fit and canÃ¢â‚¬â„¢t be placed on the selected wall.";
	}
	if (alertUsedFor == "removeCupola") {
		alertMessage = "Are you sure you want to remove this cupola?";
	}
	if (alertUsedFor == "FULLYENCLOSED") {
		alertMessage = "This action will revert your selections in CUSTOM walls to default. Click 'Ok' to continue.";
	}
	if (alertUsedFor == "ADDUTILITY") {
		alertMessage = "If you add Utility Storage, all your selections in the Custom Walls will be set to default. Click Done if you still want to continue.";
	}
	if (alertUsedFor == "captuareIMG") {
		alertMessage = "Psst! You can only click 5 photos. Consider removing an OK photo to make room for a better one. Thank you!";
	}
	if (alertUsedFor == "CancelOrderQuote") {
		if (const_var.crmSetting.is_module_name == "inventory") {
			alertMessage = "This action will reset your current selections. Please confirm if you want to proceed.";
		} else {
			alertMessage = "This action will reset your current selections. Please confirm if you want to proceed.";
		}
	}
	if (alertUsedFor == "DoorHeightGreaterThanLentoHeight") {
		alertMessage = "Height limit exceeded! The door/frameouts must not be higher than the attached Lean To.";
	}

	if (alertUsedFor == "customBuildings") {
		alertMessage = "This action will reset your current selections. Please confirm if you want to proceed.";
	}
	if (alertUsedFor == "REMOVECOMPONENT") {
		alertMessage = "Are you sure you want to delete this component?";
	}
	if (alertUsedFor == "noSpaceAvailableOnWall") {
		alertMessage = "No more components can fit on this wall. Please consider changing the wall or increasing its size.";
	}
	if (alertUsedFor == "overHeightLeanTo") {
		alertMessage = "This component's height exceeds the lean-to height. Please increase the height of the lean-to.";
	}
	if (alertUsedFor == "NoMoreGarageDoorsCanBeAdded") {
		alertMessage = "No more garage doors can be added with selected dimensions.";
	}
	if (alertUsedFor == "NoMoreWalkInDoorsCanBeAdded") {
		alertMessage = "No more walk-in doors can be added with the selected dimensions. Please increase the width, length, or height to add this walk-in door.";
	}
	if (alertUsedFor == "YourCanNotAddLeanTo") {
		alertMessage = "You cannot add a lean-to with the selected height. Please increase the height to add this lean-to.";
	}
	if (alertUsedFor == "YourCanNotAddPorch") {
		alertMessage = "Please ensure lean-tos are attached to the corners of the adjoining walls to add a wrap-around porch.";
	}
	if (alertUsedFor == "YourCanNotChangePorch") {
		alertMessage = "Changing the building size will remove the wrap-around and disconnect the lean-tos.";
	}
	if (alertUsedFor == "YourCanNotAlignPorch") {
		alertMessage = "Changing the lean-to's alignment will remove the wrap-around and disconnect the lean-tos.";
	}
	if (alertUsedFor == "YouCanNotAddPorch") {
		alertMessage = "Please ensure lean-tos are attached to the corners of the adjoining walls to add a wrap-around porch.";
	}
	if (alertUsedFor == "addComponentOnWall") {
		alertMessage = "Oops!! Did you forget to add a door to your fully enclosed building? Please see the doors and windows tab given under options panel and proceed with ordering";
	}
	if (alertUsedFor == "RoofPitchAction") {
		alertMessage = "You can't add this roof pitch with selected dimensions";
	}
	if (alertUsedFor == "onSubmitLoginApiErrorhandling") {
		alertMessage = const_var.loginErrorHandlingMessage;
	}
	if (alertUsedFor == "RoofStyleLength") {
		alertMessage = "This roof style is not available with selected size.";
	}
	if (alertUsedFor == "RegularRoofStyle") {
		let roofstyleName = const_var.roof_style.find((obj) => obj.roof_id == params.p_r_s);
		alertMessage = `These panels can't be added with a ${roofstyleName != undefined ? roofstyleName.name.toLowerCase() : "regular"} style. Please change your roof style to A-frame or vertical to add them.`;
	}
	if (alertUsedFor == "RegularRoofStyleTextureChange") {
		alertMessage = `Selected panels aren't available with this roof style and have been switched to compatible ones.`;
	}
	if (alertUsedFor == "regularRoofStyleHeight") {
		alertMessage = "This roof style is not available with selected height, please increase height to change the roof style.";
	}
	if (alertUsedFor == "nonVerticalRoofStyleForTubulerBuildingMnf") {
		alertMessage = "Changing the roof style will remove end lean-tos, do you still want to change?";
	}
	if (alertUsedFor == "endLeantosForTubulerBuildingMnf") {
		alertMessage = "Please select the Vertical Roof Style for your building to add End Lean Tos.";
	}
	if (alertUsedFor == "endLeantoPorchessForTubulerBuildingMnf") {
		alertMessage = "Wrap-around canÃ¢â‚¬â„¢t be added with this roof style, please switch to Vertical roof style to add wrap-around.";
	}
	if (alertUsedFor == "clearComponent") {
		alertMessage = "This action will remove all building components. Do you want to proceed?";
	}
	if (alertUsedFor == "changeStateOrManufacture") {
		alertMessage = "Changing the manufacturer or state will reset your building changes, requiring you to design a new building from scratch.";
	}
	if (alertUsedFor == "NoMfgExsist") {
		alertMessage = "This link is not valid/expired. Please contact to the sales executive person.";
	}
	if (alertUsedFor == "notAllowInsulationForHorizontalOrRegularRoof") {
		alertMessage = "A vertical roof style and vertical panel are both required to add insulation.";
	}

	if (alertUsedFor == "changeInstallationSurface") {
		alertMessage = "A concrete surface is required to accommodate a residential door in the building. Please choose from the options below";
	}

	if (alertUsedFor == "stateManuApiError") {
		alertMessage = "We currently do not service this location. Please contact your administrator.";
	}
	if (alertUsedFor == "notAllowNewPosition") {
		alertMessage = "Movement blocked due to overlapping components.";
	}
	if (alertUsedFor == "YouCanNotIncreaseHeight") {
		alertMessage = "This height is not available when an additional structure is attached. Modify the height to keep both buildings.";
	}
	if (alertUsedFor == "YouCanNotIncreaseWidth") {
		alertMessage = "This width is not available when an additional structure is attached. Modify the width to keep both buildings.";
	}
	if (alertMessage == "" && const_var.stripeErrorHandlingMessage != "") {
		alertMessage = const_var.stripeErrorHandlingMessage;
	}

	return alertMessage;
};
